/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */

export type GetTipiProcedimentoTipologia =
  (typeof GetTipiProcedimentoTipologia)[keyof typeof GetTipiProcedimentoTipologia];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipiProcedimentoTipologia = {
  PROCEDIMENTO: 'PROCEDIMENTO',
  ENDOPROCEDIMENTO: 'ENDOPROCEDIMENTO',
  ENTRAMBI: 'ENTRAMBI',
  PRATICA: 'PRATICA',
} as const;
